import React from "react"
import { Breadcrumb as Breadcrumbs, BreadcrumbItem, BreadcrumbLink } from "@chakra-ui/react"
import Link from "@components/Link"
import Icon from "@components/Icon/Icon"
import { useBreadcrumb } from "@hooks/useBreadcrumb"
import type { Location } from "@root/types/global"

type Props = {
  data: any
  location: Location
  theme?: "light" | "dark"
  style?: React.CSSProperties
}

const Breadcrumb: React.FC<Props> = ({ location, data, theme = "dark", style }) => {
  const { buildBreadcrumbs } = useBreadcrumb(location)
  const breadcrumbs = buildBreadcrumbs({ data })
  const isJournalSearchPage = data?.search

  return location?.pathname !== "/" ? (
    <Breadcrumbs
      spacing={0.5}
      lineHeight="16px"
      separator={<Icon name="chevronRight" size="16px" color={theme === "dark" ? "#7B7670" : "white"} />}
      sx={{
        ol: {
          paddingBottom: "6px",
          ...style
        },
      }}
    >
      {breadcrumbs.map((item, index) => {
        const isCurrentPage = isJournalSearchPage
          ? index === 2
          : location.pathname === item.url || `${item.url}/` === item.url
          ? true
          : false
        const url = location.pathname.includes("/pages/") && index > 0 ? `/pages${item.url}` : item.url

        return (
          <BreadcrumbItem
            key={item?.title?.toString()}
            color={isCurrentPage ? (theme === "dark" ? "text.primary" : "white") : theme === "dark" ? "#7B7670" : "brand.border"}
            isCurrentPage={isCurrentPage}
            alignItems="baseline"
            pointerEvents={isCurrentPage ? "none" : "auto"}
          >
            <BreadcrumbLink as={Link} to={url}>
              {item?.title?.replaceAll("-", " ")}
            </BreadcrumbLink>
          </BreadcrumbItem>
        )
      })}
    </Breadcrumbs>
  ) : null
}

export default React.memo(Breadcrumb)
